export default "__VITE_ASSET__DE9cgtp9__"